import { apiFetch, parseApiResponse } from '../../utils/apiClient';

export const getProjectTimeEntries = async (projectId) =>
  parseApiResponse(await apiFetch(`/api/time-entries/project/${projectId}`));

export const getMyTimeEntries = async ({ from, to } = {}) => {
  const params = new URLSearchParams();
  if (from) params.set('from', from);
  if (to) params.set('to', to);
  const query = params.toString() ? `?${params}` : '';
  return parseApiResponse(await apiFetch(`/api/time-entries/me${query}`));
};

export const createTimeEntry = async (payload) => parseApiResponse(await apiFetch('/api/time-entries', {
  method: 'POST',
  body: JSON.stringify(payload),
}));

export const updateTimeEntry = async (entryId, payload) => parseApiResponse(await apiFetch(`/api/time-entries/${entryId}`, {
  method: 'PUT',
  body: JSON.stringify(payload),
}));

export const deleteTimeEntry = async (entryId) => parseApiResponse(await apiFetch(`/api/time-entries/${entryId}`, {
  method: 'DELETE',
}));

export const getTimeActivities = async () => parseApiResponse(await apiFetch('/api/time-entries/activities'));

export const getMyWeekSummary = async (start) =>
  parseApiResponse(await apiFetch(`/api/time-entries/me/week?start=${encodeURIComponent(start)}`));

export const copyMyTimeDay = async (sourceDate, targetDate) => parseApiResponse(await apiFetch('/api/time-entries/me/copy-day', {
  method: 'POST', body: JSON.stringify({ sourceDate, targetDate }),
}));
